export const GENDER_OPTIONS = ['Male', 'Female', 'Other'];

export const AGE_GROUP_OPTIONS = ['1-15', '16-30', '30+'];
